import { withValidate } from "./withValidate";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSyncProp } from "../hooks/common/useSyncProp";
import { format } from "date-fns";
import { forwardRef, MouseEventHandler } from "react";
import { ThemedButton } from "./Button";

interface DatePickerProps {
  disabled?: boolean;
  defaultValue?: string;
  className?: string;
  showMonthYearPicker?: boolean;
  onChange?: (value: string) => unknown;
}
const ExampleCustomInput = forwardRef<
  HTMLButtonElement,
  {
    value?: string;
    onClick?: MouseEventHandler;
    className?: string;
  }
>(({ value, onClick, className }, ref) => (
  <ThemedButton
    type="button"
    onClick={onClick}
    color="quaternary"
    ref={ref}
    className={className}
  >
    {value}
  </ThemedButton>
));
export const DatePicker = ({
  defaultValue,
  onChange,
  className,
  ...props
}: DatePickerProps) => {
  const [value, setValue] = useSyncProp(defaultValue);
  const renderMonthContent = (month: number) => {
    return <span>{month + 1}월</span>;
  };
  const handleChange = (v: Date | null) => {
    if (v) {
      const str = format(v, "yyyy.MM");
      setValue(str);
      onChange?.(str);
    }
  };

  return (
    <ReactDatePicker
      {...props}
      customInput={<ExampleCustomInput className={className} />}
      renderMonthContent={renderMonthContent}
      value={value}
      onChange={handleChange}
      withPortal
      portalId="root"
    />
  );
};

export const ValidateDatePicker = withValidate(DatePicker);
